import __request__ from "routing/request";
export function functions(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.views/views/functions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
